<div class="menu-items">
	<ng-container *ngFor="let tuile of mobileTuiles">
		<ng-container *ngIf="!tuile.onlyDesktop">
			<div class="menu-item">
				<lua-tuile [label]="tuile.label" [iconName]="tuile.iconName" [isIcon]="tuile.isCustomIcone" [badgeCount]="tuile.badgeCount"
					(click)="tuile.onClick()"></lua-tuile>
			</div>
		</ng-container>
	</ng-container>
</div>